const getters = {
  getUser: state => {
    return state.user
  },
  getAuth: state => {
    return state.authenticated
  }
}

export default getters
